import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { spring } from "../Spring";
// import { interpolate } from "../interpolate";

const Container = styled.span`
    display: inline-flex;
    overflow: hidden;
`;

const Holder = styled.span``;

function FadeAnimation(props) {
    const frame = useCurrentFrame();

    const { children, delay = 0 } = props;

    const opactiy = spring({
        frame: frame - delay,
        fps: (props.videoConfig || {}).fps || 30,
        config: {
            damping: 200,
        },
    });

    return (
        <Container>
            <Holder
                style={{
                    opacity: opactiy,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(FadeAnimation);
